module.exports = __webpack_public_path__ + "static/media/klatre.13aa7500.mp3";